import { useUserStore } from '@/store/user'
import { needLoginPages as _needLoginPages, buildLoginUrl, getNeedLoginPages } from '@/utils'

const isDev = import.meta.env.DEV

const isLogined = () => useUserStore().isLogined

type LoginJump = (options: { url: string, fail?: (err: unknown) => void }) => void

// 来源跳转方法 → 跳登录页用的方法，尽量保真原语义（switchTab 目标是 tab 页，登录页非 tab，故用 navigateTo）
const loginJumpMap: Record<string, LoginJump> = {
  navigateTo: options => uni.navigateTo(options),
  redirectTo: options => uni.redirectTo(options),
  reLaunch: options => uni.reLaunch(options),
  switchTab: options => uni.navigateTo(options),
}

// 需拦截的跳转方法（原生 tabBar 点击不走 switchTab 拦截器，属平台限制）
const guardedMethods = ['navigateTo', 'redirectTo', 'reLaunch', 'switchTab'] as const

// 黑名单式登录守卫：默认免登录，页面 definePage() 声明 needLogin: true 才拦截
function createRouteGuard(source: (typeof guardedMethods)[number]) {
  return {
    invoke({ url }: { url: string }) {
      // 守卫按绝对路径匹配，相对路径会被放行，dev 下告警
      if (isDev && !url.startsWith('/')) {
        console.warn(`[routeInterceptor] url 建议用绝对路径，收到：${url}`)
      }
      const path = url.split('?')[0]
      // dev 实时算避免热更新遗漏，生产用预计算结果
      const needLoginPages: string[] = isDev ? getNeedLoginPages() : _needLoginPages
      // 免登录或已登录则放行
      if (!needLoginPages.includes(path) || isLogined()) {
        return true
      }
      const redirectRoute = buildLoginUrl(url)
      const jump = loginJumpMap[source] ?? loginJumpMap.navigateTo
      jump({
        url: redirectRoute,
        // 兜底：主跳转失败时降级 reLaunch，避免用户卡死
        fail(err) {
          uni.reLaunch({ url: redirectRoute })
          if (isDev) {
            console.error('[routeInterceptor] 跳登录失败，已降级 reLaunch：', err)
          }
        },
      })
      return false
    },
  }
}

export const routeInterceptor = {
  install() {
    guardedMethods.forEach((method) => {
      uni.addInterceptor(method, createRouteGuard(method))
    })
  },
}
